import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './map-container.module.scss';
import { setActiveRegion, setComparedRegion } from '../../actions/ui';
import MapBanner from './map-banner';
import RegionMap from '../region-map';
import * as selectors from '../../reducers';

const MapContainer = ({
  council,
  comparing,
  onCouncilSelect,
  isComparisonCouncil,
  comparisonId,
  setActiveRegion,
  setComparedRegion,
}) => {
  const handleCloseClicked = () => {
    if (isComparisonCouncil) {
      // Close the comparison one only
      setComparedRegion(null);
    } else {
      // Close the current active one, and make the other one active.
      setActiveRegion(comparisonId);
      // Now close the comparison one.
      setComparedRegion(null);
    }
  };

  return (
    <div
      className={`councilMapWrapper ${styles.councilWrapper}`}
      data-comparing={comparing}
    >
      <MapBanner
        council={council}
        comparing={comparing}
        onCloseClicked={handleCloseClicked}
      />
      <div className={`${styles.mapWrapper}`}>
        <RegionMap
          council={council}
          onCouncilSelect={onCouncilSelect}
          scrollZoom={false}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
};

const mapStateToProps = (state) => ({
  isMobile: selectors.getIsMobile(state),
});

MapContainer.propTypes = {
  onCouncilSelect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer);



// WEBPACK FOOTER //
// ./src/components/map-container/MapContainer.js